import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuthToken from "../../hooks/useAuthToken";
import { getProfile } from "../../api/auth";
import { useLanguage } from "../../context/LanguageContext";

const RequireOwner = ({ children }) => {
  const { t } = useLanguage();
  const { isAuthenticated, logout } = useAuthToken();
  const location = useLocation();
  const [status, setStatus] = useState(isAuthenticated ? "checking" : "no-session");

  useEffect(() => {
    if (!isAuthenticated) {
      setStatus("no-session");
      return;
    }

    let cancelled = false;

    const verify = async () => {
      try {
        const profile = await getProfile();
        const role = profile?.role ?? profile?.Role;
        if (!cancelled) {
          setStatus(role === "Owner" ? "ok" : "forbidden");
        }
      } catch {
        await logout();
        if (!cancelled) setStatus("no-session");
      }
    };

    verify();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, logout]);

  if (status === "checking") {
    return <div className="auth-loading">{t("auth.loading.checkingAccess", "Checking access...")}</div>;
  }

  if (status === "no-session") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (status === "forbidden") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireOwner;
